
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"80","height":"80"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 1690","transform":"translate(.499 .488)"}},[_c('circle',{attrs:{"data-name":"Ellipse 313","cx":"40","cy":"40","r":"40","transform":"translate(-.499 -.488)","fill":"#f56363"}}),_c('g',{attrs:{"data-name":"Group 1687","fill":"none","stroke":"#fff","stroke-linecap":"round","stroke-width":"8"}},[_c('path',{attrs:{"data-name":"Path 1452","d":"M23.696 54.428l30.639-30.641"}}),_c('path',{attrs:{"data-name":"Path 1453","d":"M23.696 23.787l30.641 30.641"}})])])])
          )
        }
      }
    